var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_471_5012",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_471_5012)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5028 3.10285C18.44 2.16559 19.9598 2.16559 20.897 3.10285C21.8343 4.0401 21.8343 5.5597 20.897 6.49696L11.794 15.5999H8.3999V12.2058L17.5028 3.10285ZM4.7999 4.7999C3.47442 4.7999 2.3999 5.87442 2.3999 7.1999V19.1999C2.3999 20.5254 3.47442 21.5999 4.7999 21.5999H16.7999C18.1254 21.5999 19.1999 20.5254 19.1999 19.1999V14.3999C19.1999 13.7372 18.6627 13.1999 17.9999 13.1999C17.3371 13.1999 16.7999 13.7372 16.7999 14.3999V19.1999H4.7999V7.1999H9.5999C10.2626 7.1999 10.7999 6.66264 10.7999 5.9999C10.7999 5.33717 10.2626 4.7999 9.5999 4.7999H4.7999Z",
    fill: "#FFB829"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.99e4e8b014f07c42ac5a420f481fdecd.svg";
export { ForwardRef as ReactComponent };